<template>
  <div class="relative" :class="$style.root">
    <div
      class="absolute inset-0 w-full h-full border-2 border-current rounded-full"
      :class="$style.top"
    ></div>
    <div
      class="absolute inset-0 w-full h-full border-2 border-current rounded-full"
      :class="$style.bottom"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'AppLoading'
}
</script>

<style lang="postcss" module>
.root {
  width: 1em;
  height: 1em;
}
.top {
  border-right-color: transparent;
  animation: rotate theme('durations.slow-2')
    theme('timingFunctions.expressive-standard') 0s infinite;
}

.bottom {
  @apply opacity-50;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
